// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"af43e398","511":"3ce7f1bd","728":"0d412682"}[chunkId] + ".chunk.js";
};